import { MutableRefObject, useEffect, useRef } from 'react'

let pollingIntervalId: NodeJS.Timeout = null

export const useInfinityScroll = (
  ref: MutableRefObject<any>,
  onLoadMoreRef: MutableRefObject<() => void>,
  shouldTriggerLoadMore: boolean = true,
  {
    rootMargin = '50px 0px',
    pollingInterval = null,
  }: { rootMargin?: string; pollingInterval?: number } = {}
) => {
  const observable = useRef<IntersectionObserver>(null)

  useEffect(() => {
    if (!shouldTriggerLoadMore) {
      clearInterval(pollingIntervalId)
    }

    observable.current = new IntersectionObserver(
      (elements) => {
        const intersectionRatio = elements[0].intersectionRatio
        if (intersectionRatio > 0 && shouldTriggerLoadMore) {
          onLoadMoreRef.current()

          if (pollingInterval) {
            pollingIntervalId = setInterval(() => {
              onLoadMoreRef.current()
            }, pollingInterval)
          }
        }
      },
      { rootMargin }
    )

    if (ref.current !== null) {
      clearInterval(pollingIntervalId)
      observable.current.observe(ref.current)
    }

    return () => {
      clearInterval(pollingIntervalId)
      observable.current.disconnect()
    }
  }, [shouldTriggerLoadMore])
}
